import { Component, OnInit } from '@angular/core';
import { ParentChildService } from '../../../../../components/parentchild/parentchild.service';
import { ConfirmationService } from 'primeng/primeng';
import { PromotionsSModel } from './promotionsSQ.model';
import { LocalStorageService } from 'ng2-webstorage';
import { MessageService } from 'primeng/components/common/messageservice';
import { DataAnalyticsService } from '../../../../../components/dataAnalytics/dataAnalytics.service';
@Component({
  selector: 'promotionsSQ',
  templateUrl: 'promotionsSQ.component.html',
  styleUrls: ['promotionsSQ.component.scss']
})

export class PromotionsSQComponent implements OnInit {

  public selected_branch: any;
  public Branches: any;
  public selectedYear1: any;
  public selectedGrade1: any;
  public selectedSection1: any;
  public selectedYear2: any;
  public selectedGrade2: any;
  public selectedSection2: any;
  public YearData: any;
  public mappedData: any;
  public sectionList1: any;
  public sectionList2: any;
  public students1: any;
  public students2: any;

  public addDepartmentmodel = new PromotionsSModel();
  public schoolId: any;
  public department: any;
  // display: boolean = false;
  display = "none"
  public maxSize: number = 10;
  public bigTotalItems: number;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  public searchString: string;
  public spinnershow: boolean = false;
  public rolesList: any;
  public departmentList: any;
  public info:boolean=false;
  public isList:boolean=true;
  constructor(private dataAnalyticsService: DataAnalyticsService, private parentChildService: ParentChildService, private messageService: MessageService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService) {
    this.schoolId = this.localStorage.retrieve('SchoolId');

  }

  ngOnInit() {
      this.getYearData();
  }

  confirmOnClick(){
      alert("clicked");
  }

  private getYearData() {
    this.dataAnalyticsService.getYear()._finally(() => { }).subscribe(
      response => {
        this.YearData = response['yearList'];

        try {
            this.selectedYear1 = this.YearData[1];
            this.selectedYear2 = this.YearData[0];
        } catch (error) {

        }

        this.getClassSection();
      }
    )
  }

  private getClassSection() {
    this.dataAnalyticsService.getClassSectionMap().finally(() => { }).subscribe(
        response => {
            let mappedData: any = response;
            mappedData.forEach(standard => {
                standard['Sections'].forEach(section => {
                    section['StdId'] = standard['standardId'];
                    section['StdName'] = standard['standardsName'];
                    section['selected'] = false;
                });
            });
            mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
            this.mappedData = mappedData;
            try {
                this.selectedGrade1 = mappedData[0];
                this.sectionList1 = mappedData[0].Sections;
                this.selectedSection1 = mappedData[0].Sections[0];
                this.getStudentData1(this.selectedGrade1.standardId, this.selectedSection1.SectionId, this.selectedYear1.YearId);
            } catch (error) {

            }
            try {
                this.selectedGrade2 = mappedData[1];
                this.sectionList2 = mappedData[1].Sections;
                this.selectedSection2 = mappedData[1].Sections[0];
                this.getStudentData2(this.selectedGrade2.standardId, this.selectedSection2.SectionId, this.selectedYear2.YearId);
            } catch (error) {

            }

        },
        error => {
        });
  };

  getSectionByGrade1(grade) {
    this.sectionList1 = grade.Sections;
    try {
        this.selectedSection1 = grade.Sections[0];
        this.getStudentData1(this.selectedGrade1.standardId, this.selectedSection1.SectionId, this.selectedYear1.YearId);
    } catch (error) {

    }
  }

  getSectionByGrade2(grade) {
    this.sectionList2 = grade.Sections;
    try {
        this.selectedSection2 = grade.Sections[0];
        this.getStudentData2(this.selectedGrade2.standardId, this.selectedSection2.SectionId, this.selectedYear2.YearId);
    } catch (error) {

    }
  }

  getGclClassesListById1(year, grade, section){
      console.log(year, grade, section);
      this.getStudentData1(this.selectedGrade1.standardId, this.selectedSection1.SectionId, this.selectedYear1.YearId);
  }

  getGclClassesListById2(year, grade, section){
      console.log(year, grade, section);
      this.getStudentData2(this.selectedGrade2.standardId, this.selectedSection2.SectionId, this.selectedYear2.YearId);
  }


  private getStudentData1(StandardId,SectionId,AcademicYear) {
    this.dataAnalyticsService.getStudents(StandardId,SectionId,AcademicYear)._finally(() => { }).subscribe(
      response => {
        this.students1 = response['studentsList'];
        console.log("studentsList1", this.students1);
      }
    )
  }

  private getStudentData2(StandardId,SectionId,AcademicYear) {
    this.dataAnalyticsService.getStudents(StandardId,SectionId,AcademicYear)._finally(() => { }).subscribe(
      response => {
        this.students2 = response['studentsList'];
        console.log("studentsList2", this.students2);
      }
    )
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/parentchild/promotionsSQ/promotionsSQ.component.ts